module.exports = __webpack_public_path__ + "static/media/FD2.c5e19606.png";